"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "serrara-fontana": {
    "f0aa0ef1": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "skipSearch": false
    }],
    "calimera": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0b818dc9": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "skipSearch": false
    }],
    "ciglio": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "223edebb": [{
      "hkey": "c86b00c9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "fontana": [{
      "hkey": "c86b00c9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "serrara-fontana"
    }],
    "5600cafe": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "skipSearch": false
    }],
    "noia": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "319ae3bb": [{
      "hkey": "c86b00c9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "skipSearch": false
    }],
    "serrara": [{
      "hkey": "c86b00c9",
      "slug": "centro",
      "name": "Centro",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "a8286f95": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "skipSearch": false
    }],
    "succhivo": [{
      "hkey": "2d32078e",
      "slug": "serrara-fontana",
      "name": "Serrara Fontana",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;